import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Controller, FieldErrors, FieldValues, Control, Path } from 'react-hook-form'

import { Staff } from '@/core/models/staff.model'

export type PerformerSelectProps<T extends FieldValues = FieldValues> = {
    staffList: Staff[]
    control: Control<T>
    errors: FieldErrors
    name?: Path<T>
}

export function PerformerSelect<T extends FieldValues = FieldValues>({
    staffList,
    control,
    errors,
    name = 'performedById' as Path<T>,
}: PerformerSelectProps<T>) {
    const { t } = useTranslation()

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: t('common.validation.required', { defaultValue: 'This field is required' }) }}
            render={({ field }) => (
                <FormControl fullWidth required error={!!errors[name]}>
                    <InputLabel>{t('medicalAct.record.performedBy', { defaultValue: 'Performed By' })}</InputLabel>
                    <Select {...field} label={t('medicalAct.record.performedBy', { defaultValue: 'Performed By' })}>
                        {staffList.map((staff) => (
                            <MenuItem key={staff._id} value={staff._id}>
                                {staff.userInfo?.name} {staff.userInfo?.surname}
                                {staff.status && ` - ${staff.status}`}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors[name] && (
                        <Typography variant="caption" color="error">
                            {errors[name]?.message as string}
                        </Typography>
                    )}
                </FormControl>
            )}
        />
    )
}
